import React, { useCallback, useEffect, useRef, useState } from 'react'
import styles from './style.module.css';
import Button from '../../../design-system/lib/Button';
import { IC_SEARCH, Plus_Dark, filterPlus , ic_circle_close} from '../../../assets';
import { useDispatch, useSelector } from 'react-redux';
import DropDown from '../../../design-system/lib/DropDown';
import { Add_ActiveFilter, clearAll_ActiveFilter } from '../../../Redux/actions/actionNames';
import Typography from '../../../design-system/lib/Typography';
import { defTable, initTable } from '../../../Redux/reducers/table';
import _ from 'lodash';
import IconProvider from '../../../design-system/lib/IconProvider';
import { LocalData } from '../../../service/localStorage';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

const localData = new LocalData();


function Addilter({heightOnChange}) {

      const { t } = useTranslation();
  
  const activeFilters = useSelector((state) => state.Table.activeFilters)
  const filters = useSelector((state) => state.Table.filters)

  const dispatch = useDispatch();

  // const [filter1, setFilter1] = useState(null);

  const handleSelectFilter = React.useCallback((id) => {
    dispatch(Add_ActiveFilter({
      ...id,
      title :id.stage
    }))
  }, [activeFilters]);


  const filterList = React.useCallback((list) => {
    return list.filter((item)=>{
      return activeFilters.findIndex((itemx) => { return item.stage == itemx.stage }) == -1
    })
  }, [activeFilters]);

  const canClearAll = React.useCallback(() => {
    let DEFf = JSON.parse(JSON.stringify(defTable.filters))
    delete DEFf.type
    delete DEFf.cursor
    delete DEFf.cursorSort

    let NEWf = JSON.parse(JSON.stringify(filters))
    delete NEWf.type
    delete NEWf.cursor
    delete NEWf.cursorSort

    console.log("grgrbgrfg b " , DEFf , NEWf)
    return (!_.isEqual(DEFf , NEWf))
  }, [filters]);

  const ClearAll = React.useCallback((id) => {
    dispatch(clearAll_ActiveFilter())
  }, [activeFilters]);


  filterList(List(t))
  return (  
    <>
     { filterList(List(t)).length > 0 && <DropDown placement='bottomStart' noArrowIcon={true} icon={filterPlus} size='Small' data={filterList(List(t))} text={t('More')} onClick={handleSelectFilter} className={styles.DropDown}  checkSelected='full' />}
      {canClearAll() && <Typography onClick={ClearAll} weight='Body_Tiny_Bold' textColor='Primary' text={t('Clear All')} style={{cursor:"pointer"}} />}
    </>
  
  )
}


export default Addilter


const List = (t) => [
  {
    title: t("ReferenceId"),
    stage: "referenceId",
    type: "regex"
  },
  
  {
    title: t("Note"),
    stage: "note",
    type: "regex"
  },
  {
    title: t("PickupAddress"),
    stage: "pickupAddress",
    type: "regex"
  },
  {
    title: t("DeliveryAddress"),
    stage: "deliveryAddress",
    type: "regex"
  },
  {
    title: t("Driver Username"),
    stage: "driverUsername",
    type: "regex"
  },

  {
    title: t("Driver Name"),
    stage: "driverName",
    type: "regex"
  },
  {
    title: t("Driver Phone"),
    stage: "driverPhone",
    type: "regex"
  },
  {
    title: t("Customer Email"),
    stage: "customerEmail",
    type: "regex"
  },
  {
    title: t("Customer Name"),
    stage: "customerName",
    type: "regex"
  },
  {
    title: t("Customer Phone"),
    stage: "customerPhone",
    type: "regex"
  },
  {
    title: t("Price"),
    stage: "price",
    type: "range"
  },
  {
    title: t("CodAmount"),
    stage: "codAmount",
    type: "range"
  },
  {
    title: t("paymentMethods"),
    stage: "paymentMethods",
    type: "checkbox"
  },
  {
    title: t("pickupAddressDetail"),
    stage: "pickupAddressDetail",
    type: "regex"
  },
  {
    title: t("PickupCompleteAfter"),
    stage: "pickupcompleteAfter",
    type: "range"
  },
  {
    title: t("PickupcompleteBefore"),
    stage: "pickupcompleteBefore",
    type: "range"
  },
  {
    title: t("PickupFullName"),
    stage: "pickupFullName",
    type: "regex"
  },
  {
    title: t("PickupPhone"),
    stage: "pickupPhone",
    type: "regex"
  },
  
  {
    title: t("DeliveryAddressDetail"),
    stage: "deliveryAddressDetail",
    type: "regex"
  },



    {
    title: t("DeliveryCompleteAfter"),
    stage: "deliverycompleteAfter",
    type: "range"
  },
  {
    title: t("DeliverycompleteBefore"),
    stage: "deliverycompleteBefore",
    type: "range"
  },
  {
    title: t("DeliveryFullName"),
    stage: "deliveryFullName",
    type: "regex"
  },
  {
    title: t("DeliveryPhone"),
    stage: "deliveryPhone",
    type: "regex"
  },
  {
    title: t("Delivery Attempts Count"),
    stage: "deliveryAttemptNumber",
    type: "regex"
  },
  {
    title: t("Delivery Last Attempt Reason"),
    stage: "deliveryLastAttemptReason",
    type: "regex"
  },
  {
    title: t("Pickup Failed Reason"),
    stage: "pickupFailedReason",
    type: "regex"
  },

  // {
  //   title: "code",
  //   stage: "code",
  //   type: "regex"
  // },






  // {
  //   title: "pickupDescription",
  //   stage: "pickupDescription",
  //   type: "regex"
  // },
  // {
  //   title: "address",
  //   stage: "address",
  //   type: "regex"
  // },






  // {
  //   title: "routeName",
  //   stage: "routeName",
  //   type: "regex"
  // },
  // {
  //   title: "services",
  //   stage: "services",
  //   type: "checkbox"
  // },
  // {
  //   title: "vehicleTypes",
  //   stage: "vehicleTypes",
  //   type: "checkbox"
  // },
  // {
  //   title: "zones",
  //   stage: "zones",
  //   type: "checkbox"
  // },
  // {
  //   title: "type",
  //   stage: "type",
  //   type: "radioButton"
  // },
  // {
  //   title: "createdAt",
  //   stage: "createdAt",
  //   type: "range"
  // },
  // {
  //   title: "statusUpdatedAt",
  //   stage: "statusUpdatedAt",
  //   type: "range"
  // },

  // {
  //   title: "dueDate",
  //   stage: "dueDate",
  //   type: "range"
  // },

  
  // {
  //   title: "pickupzones",
  //   stage: "pickupzones",
  //   type: "checkbox"
  // },

  // {
  //   title: "deliveryzones",
  //   stage: "deliveryzones",
  //   type: "checkbox"
  // },

].map((item)=>{
  return {
     title: <> <IconProvider size='14' Icon={filterPlus} /> {item.title}</>,
     stage: item.stage,
     type: item.type
  }
})